import axios from "../../axios-auth";
import qs from "qs";
import { i18n, PREFIX } from "../../i18n.js";
import { pathOr } from "ramda";
import hash from "object-hash";
import { getTranslatedMatrixValue } from "../../helpers/helpers";
import constants from "../../helpers/constants";
import { get } from "jquery";

const state = {
  changeOptionsData: {},
  oldChangeOptionsData: {},
  isChangeOptionsLoading: false,
  isPageOptionsLoading: false,
  beforeChangeOptionsCallback: null,
  afterChangeOptionsCallback: null,
  afterChangePageOptionCallback: null,
  onCartSubmitCallback: _ => _,
  addToCartCallbacks: [],
  initFinalizeCallback: null,
  photoMappingCallback: null,
  matrixOneSelection: false,
  callChangeOptions: true,
  quantityCode: null,
  prevChangeOptionsData: null
};

const getters = {
  getCimpressOptionName: (state, getters) => code => {
    return pathOr(
      "",
      ["page_options", code, "label"],
      getters.getActiveProductPart[0]
    );
  },
  getCimpressSummary: (state, getters) => {
    const selection =
      getters.getChangeOptionsDataPPOpt["PP_" + getters.getCimpressProductId];
    let summary = [];
    var data = {};
    for (var key in selection) {
      if (
        Array.isArray(selection[key]) &&
        selection[key].length > 0 &&
        selection[key][0]
      ) {
        data[
          getTranslatedMatrixValue(
            getters.getCimpressOptionName(key),
            PREFIX.PO
          )
        ] = getTranslatedMatrixValue(selection[key][0], PREFIX.POV);
      }
    }
    summary.push({
      name: getTranslatedMatrixValue(getters.getCimpressProductId, PREFIX.PP),
      data
    });

    return summary;
  },

  getCimpressChangeOptionsData: state => {
    return pathOr([], ["changeOptionsData", "cimpress"], state);
  },
  getCimpressRemainingOptions: state => data => {
    return pathOr(
      null,
      ["changeOptionsData", "cimpress", "remainingOptions", data.pp, data.po],
      state
    );
  },
  getCimpressAttributeResolveStrategy: state => {
    return pathOr(
      {},
      ["changeOptionsData", "cimpress", "resolvedAttributesStrategy"],
      state
    );
  },
  getCimpressInformationalAttributes: state => {
    return pathOr(
      [],
      ["changeOptionsData", "cimpress", "informationalAttributes"],
      state
    );
  },
  getIsCimpressSelectionResolved: (state, getters) => {
    return (
      !getters.getIsCimpressProduct ||
      constants.CIMPRESS_STATE_FULLY_RESOLVED === getters.getCimpressState
    );
  },
  getCimpressQtyRanges: (state, getters) => {
    return pathOr(
      [],
      [
        "changeOptionsData",
        "cimpress",
        "remainingOptions",
        getters.getActiveProductPartCode,
        "Quantity",
        "ranges"
      ],
      state
    );
  },
  getCimpressState: state => {
    return pathOr(null, ["changeOptionsData", "cimpress", "state"], state);
  },
  getOldChangeOptionsData: state => {
    return state.oldChangeOptionsData;
  },
  getSummarySelectedPageOptions: (state, getters) => {
    var summary = [];
    for (let pp in state.changeOptionsData.product_selection.productparts) {
      var ppObj = state.changeOptionsData.product_selection.productparts[pp];
      var data = {};
      for (let pageOptionKey in ppObj.prodpart_options) {
        if (
          getters.getIsCheckedPageOptionActive &&
          !getters.getCheckedInPP({ po_name: pageOptionKey, pp: pp })
        ) {
          continue;
        }
        var item = ppObj.prodpart_options[pageOptionKey];
        if (
          pageOptionKey == "format" &&
          item.po_value.startsWith("Custom format")
        ) {
          data[i18n.t(PREFIX.PO + item.po_name)] = item.po_value.replace(
            "Custom format",
            i18n.t("Custom format")
          );
        } else {
          data[i18n.t(PREFIX.PO + item.po_name)] = i18n.t(
            PREFIX.POV + item.po_value
          );
        }
      }
      if (Object.keys(data).length != 0) {
        var summaryItem = {
          name: i18n.t(PREFIX.PP + ppObj.prodpart_name),
          data
        };

        summary.push(summaryItem);
      }
    }
    return summary;
  },
  getPrevChangeOptionsData: state => {
    return state.prevChangeOptionsData;
  },
  getPersonalizationCustomPrices: state => {
    var prices = {};
    for (var qty in state.changeOptionsData.price_table) {
      if (qty.includes("custom_qty_")) {
        if (
          state.changeOptionsData.price_table[qty].hasOwnProperty(
            "formatted_base_price"
          )
        ) {
          prices[state.changeOptionsData.price_table[qty].quantity] =
            state.changeOptionsData.price_table[qty].formatted_base_price;
        } else {
          prices[state.changeOptionsData.price_table[qty].quantity] = i18n.n(
            state.changeOptionsData.price_table[qty].base_price,
            "currency"
          );
        }
      }
    }

    return prices;
  },
  getQuantityCode: state => {
    return state.quantityCode;
  },
  getChangeOptionsTemplate: state => {
    var template = pathOr(0, ["changeOptionsData", "template"], state);
    if (template && template.length == 0) {
      return 0;
    }
    return template;
  },
  getCallChangeOptions: state => {
    return state.callChangeOptions;
  },
  getMatrixOneSelection: (state, getters) => {
    if (getters.getIsUploadWithoutConfiguration) {
      return true;
    }
    return state.matrixOneSelection;
  },
  getPackingTdTexturesFromTemplateMapping: state => {
    return state.changeOptionsData.td_data
      ? state.changeOptionsData.td_data
      : null;
  },

  getSelectedOption: (state, getters) => data => {
    if (getters.getIsMyAccount) {
      return getters.getMyAccountSelection["PP_" + data.pp][data.option];
    } else if (!state.callChangeOptions) {
      return "";
    }
    return state.changeOptionsData.pp_opt["PP_" + data.pp][data.option];
  },
  getQuantity: (state, getters) => {
    if (getters.getPersonalizationQuantityWithPrice) {
      return getters.getQuantityField;
    }
    if (state.changeOptionsData.qty != undefined) {
      return state.changeOptionsData.qty;
    }
    return getters.getQuantityField;
  },
  getSummary: (state, getters) => {
    if (getters.getIsCimpressProduct) {
      return getters.getCimpressSummary;
    }
    var summary = [];
    for (let pp in state.changeOptionsData.product_selection.productparts) {
      var ppObj = state.changeOptionsData.product_selection.productparts[pp];
      var data = {};
      for (let pageOptionKey in ppObj.prodpart_options) {
        var item = ppObj.prodpart_options[pageOptionKey];

        data[
          getTranslatedMatrixValue(item.po_name, PREFIX.PO)
        ] = getTranslatedMatrixValue(item.po_value, PREFIX.POV);
      }
      var summaryItem = {
        name: getTranslatedMatrixValue(ppObj.prodpart_name, PREFIX.PP),
        data
      };

      summary.push(summaryItem);
    }
    return summary;
  },
  getPhotoMapping: state => {
    return state.changeOptionsData.photo ? state.changeOptionsData.photo : null;
  },
  getFactsheet: state => {
    return state.changeOptionsData.factsheet_files
      ? state.changeOptionsData.factsheet_files
      : null;
  },
  getIsChangeOptionsEmpty: state => {
    var no_qty = Object.keys(state.changeOptionsData).filter(el => {
      return el != "qty";
    });
    return no_qty.length == 0;
  },
  getIsPageOptionsLoading: (state, getters) => {
    return getters.getEnableLoader ? state.isPageOptionsLoading : false;
  },
  getBeforeChangeOptionsCallback: state => {
    return state.beforeChangeOptionsCallback;
  },
  getAfterChangeOptionsCallback: state => {
    return state.afterChangeOptionsCallback;
  },
  getAfterChangePageOptionCallback: state => {
    return state.afterChangePageOptionCallback;
  },
  getInitFinalizeCallback: state => {
    return state.initFinalizeCallback;
  },
  getPhotoMappingCallback: state => {
    return state.photoMappingCallback;
  },
  getAddToCartCallbacks: state => {
    return state.addToCartCallbacks;
  },
  getOnCartSubmitCallback: state => {
    return state.onCartSubmitCallback;
  },
  getChangeOptionsPostData: (
    state,
    getters,
    rootState,
    rootGetters
  ) => makeCall => {
    if (getters.getIsChangeOptionsEmpty) {
      const initialValue = rootGetters.getInitialChangeOptionsPostData; //getters
      if (getters.getIsCimpressProduct) {
        initialValue.qty = getters.getWebProductData.quantity;
      }
      return initialValue;
    }

    var qties = rootGetters.getCustomQuantitiesLabels;

    let postData = {
      webproduct: rootGetters.getWebProductId,
      qty: state.changeOptionsData.qty,
      custom_quantities: qties.length == 0 ? "" : qties
    };
    if (getters.getIsCimpressProduct) {
      postData.is_cimpress_product = true;
      postData.cimpress_product_id = getters.getCimpressProductId;
    }
    if (getters.getStoreCode) {
      postData["store_code"] = getters.getStoreCode;
    }
    if (getters.getAppSelectionId) {
      postData["selection"] = getters.getSelectionId;
    }

    var data = state.changeOptionsData;

    for (let option in data.pp_opt) {
      if (option.startsWith("PP_")) {
        for (let attribute in data.pp_opt[option]) {
          let value = Array.isArray(data.pp_opt[option][attribute])
            ? data.pp_opt[option][attribute][0]
            : data.pp_opt[option][attribute];
          if (getters.getCimpressNoQuantity && "Quantity" == attribute) {
            continue;
          }
          if (makeCall) {
            if (getters.getIsCimpressProduct) {
              const ppKey = option.replace("PP_", "");
              const attributeRezolveStrategies =
                getters.getCimpressAttributeResolveStrategy;
              // implied
              if ("implied" === attributeRezolveStrategies[ppKey][attribute]) {
                value = "";
              } else {
                /*console.log(
                  "Not implied " + attribute + " but - ",
                  attributeRezolveStrategies[ppKey][attribute]
                );*/
              }
            }
            if ("Quantity" == attribute) {
              value = postData.qty;
            }
          }
          postData[
            "print_options[" + option + "][" + attribute + "][]"
          ] = value;
        }
      } else if (option.startsWith("PP")) {
        postData["print_options[" + option + "][]"] =
          rootGetters.getActiveProductPartCode;
      } else {
        if (makeCall) {
          if (Array.isArray(data.pp_opt[option][option])) {
            if (data.pp_opt[option][option].length) {
              postData["print_options[" + option + "][" + option + "]"] =
                data.pp_opt[option][option];
            } else {
              postData["print_options[" + option + "][" + option + "][]"] = "";
            }
          } else {
            postData["print_options[" + option + "][" + option + "][]"] =
              data.pp_opt[option][option];
          }
        } else {
          if (Array.isArray(data.pp_opt[option][option])) {
            if (data.pp_opt[option][option].length) {
              for (var item in data.pp_opt[option][option]) {
                postData[
                  "print_options[" + option + "][" + option + "][" + item + "]"
                ] = data.pp_opt[option][option][item];
              }
            } else {
              postData["print_options[" + option + "][" + option + "][]"] = "";
            }
          } else {
            postData["print_options[" + option + "][" + option + "][]"] =
              data.pp_opt[option][option];
          }
        }
      }
    }

    var preflightInfo = getters.getPreflightSendData;
    postData = { ...postData, ...preflightInfo };

    return postData;
  },
  getChangeOptionsHiddenInputs: (state, getters, rootState, rootGetters) => {
    var data = getters.getChangeOptionsPostData(false);
    delete data.qty; // not needed

    // add new field for packing
    if (getters.getIsPackingEnabled) {
      var packingData = getters.getPackingHiddenInputs;
      data = { ...data, ...packingData };
    }
    if (getters.getIsCimpressProduct) {
      const informationalAttributes = {};
      const attributes = getters.getCimpressInformationalAttributes;
      for (const attributeKey in attributes) {
        const key = `cimpressInformationalAttributes[${attributeKey}]`;
        informationalAttributes[key] = attributes[attributeKey];
      }
      data = {
        ...data,
        ...{
          is_cimpress_product: true,
          cimpress_product_id: getters.getCimpressProductId
        },
        ...informationalAttributes
      };
    }

    if (getters.getShowCostCenter) {
      data["costcenter_number"] = getters.getCostCenter;
    }

    /*if (getters.getStoreCode) {
      data["store_code"] = getters.getStoreCode;
    }*/

    return data;
  },
  getChangeOptionsData: state => {
    return state.changeOptionsData;
  },
  getChangeOptionsDataPPOpt: state => {
    return state.changeOptionsData.pp_opt;
  },
  getQuantities: state => {
    var items = [];
    for (var qty in state.changeOptionsData.price_table) {
      var item = {
        code: qty,
        // code: state.changeOptionsData.price_table[qty].quantity,
        ...state.changeOptionsData.price_table[qty]
      };

      if (
        state.changeOptionsData.qty ==
        state.changeOptionsData.price_table[qty].quantity
      ) {
        item["active"] = true;
      }

      items.push(item);
    }

    items.sort(function (a, b) {
      var inta = parseInt(a.quantity);
      var intb = parseInt(b.quantity);
      return inta == intb ? 0 : inta > intb ? 1 : -1;
    });

    return items;
  },
  getHasGrossPrice: state => {
    for (const qty of Object.keys(state.changeOptionsData.price_table)) {
      if (state.changeOptionsData.price_table[qty].gross_price) {
        return true;
      }
      break;
    }
    return false;
  },
  getQuantitiesValues: state => {
    var items = [];
    for (var qty in state.changeOptionsData.price_table) {
      items.push(state.changeOptionsData.price_table[qty].quantity);
    }
    return items;
  },
  getDenyRules: state => {
    return state.changeOptionsData.deny_rules;
  },
  getInformation: state => {
    return state.changeOptionsData.information;
  },
  getShowChangeOptionsLoader: (state, getters) => {
    return getters.getEnableLoader ? state.isChangeOptionsLoading : false;
  },
  getIsChangeOptionsLoading: (state, getters) => {
    return state.isChangeOptionsLoading;
  }
};

const mutations = {
  setCimpressChangeOptionsData: (state, payload) => {
    state.changeOptionsData = {
      ...state.changeOptionsData,
      cimpress: payload
    };
  },
  setCimpressChangeOptionsDataStatus: (state, payload) => {
    state.changeOptionsData = {
      ...state.changeOptionsData,
      cimpress: {
        ...state.changeOptionsData.cimpress,
        state: payload
      }
    };
  },
  setMatrixOneSelection: (state, payload) => {
    state.matrixOneSelection = payload;
  },
  setIsChangeOptionsLoading: (state, payload) => {
    state.isChangeOptionsLoading = payload;
  },
  setOldChangeOptionsData: (state, payload) => {
    state.oldChangeOptionsData = payload;
  },

  setPageOption: (state, { getters, rootState, payload, dispatch }) => {
    var activePageOption = getters.getActivePageOptions;
    if (payload.option) {
      activePageOption = payload.option;
    }

    if (getters.getAfterChangePageOptionCallback) {
      dispatch("callAfterChangePageOptionCallback", {
        value: payload.value,
        option: activePageOption,
        type: "main"
      });
    }
    // array values set ???
    var changeOptionsDataPPOpt = { ...getters.getChangeOptionsDataPPOpt };
    changeOptionsDataPPOpt["PP_" + rootState.webproduct.activeProductPartCode][
      activePageOption
    ] = [payload.value];
    state.changeOptionsData.pp_opt = changeOptionsDataPPOpt;

    if (getters.getIsCimpressPreferredSelection) {
      return;
    }
    if (!getters.getIsCimpressProduct) {
      dispatch("moveToNextPageOption", payload);
    }
  },
  setPageOptionCimpressOneValue: (state, { getters, payload }) => {
    var changeOptionsDataPPOpt = { ...getters.getChangeOptionsDataPPOpt };
    changeOptionsDataPPOpt["PP_" + getters.getActiveProductPartCode][
      payload.option
    ] = [payload.value];
    state.changeOptionsData.pp_opt = changeOptionsDataPPOpt;
  },
  moveToNextPageOption: (state, { rootState, getters, payload, dispatch }) => {
    if (payload && payload.layout) {
      var activePageOption = getters.getActivePageOptions;
      if (payload.option) {
        activePageOption = payload.option;
      }
      // move to the next item
      var activePageOptions = { ...rootState.webproduct.activePageOptions };
      var activeProductPageOptionsKyes = Object.keys(
        getters.getActiveProductPageOptions
      );
      var index = activeProductPageOptionsKyes.indexOf(activePageOption);
      if (index > -1) {
        const checkedData = {
          pp: rootState.webproduct.activeProductPartCode,
          po_index: index
        };
        dispatch("setCheckedPOItem", checkedData);

        if (index != activeProductPageOptionsKyes.length - 1) {
          activePageOptions[rootState.webproduct.activeProductPartCode] =
            activeProductPageOptionsKyes[++index];
          rootState.webproduct.activePageOptions = activePageOptions;
        } else {
          // move to the next PP if it exists
          var productPartsCodesKeys = getters.getProductPartsCodes;
          var indexPP = productPartsCodesKeys.indexOf(
            rootState.webproduct.activeProductPartCode
          );
          if (indexPP != -1) {
            if (indexPP != productPartsCodesKeys.length - 1) {
              rootState.webproduct.activeProductPartCode =
                productPartsCodesKeys[++indexPP];
              activePageOptions[
                rootState.webproduct.activeProductPartCode
              ] = Object.keys(getters.getActiveProductPageOptions)[0];
              rootState.webproduct.activePageOptions = activePageOptions;
            } else {
              // finalized selection for all PP
              dispatch("setMatrixComplete", true);
              //rootState.config.showUpload = true;
            }
          }
        }
      }
    }
  },
  setOtherOption: (state, { getters, payload, dispatch }) => {
    var changeOptionsDataPPOpt = { ...getters.getChangeOptionsDataPPOpt };
    changeOptionsDataPPOpt[payload.option][payload.option] = Array.isArray(
      payload.value
    )
      ? payload.value
      : [payload.value];
    state.changeOptionsData.pp_opt = changeOptionsDataPPOpt;

    if (getters.getAfterChangePageOptionCallback) {
      dispatch("callAfterChangePageOptionCallback", {
        value: payload.value,
        option: payload.option,
        type: "other"
      });
    }
  },
  setChangeOptionsData: (state, payload) => {
    state.changeOptionsData = payload;
  },
  setQuantity: (state, payload) => {
    state.changeOptionsData = { ...state.changeOptionsData, qty: payload.qty };
    state.quantityCode = payload.qtyCode;
  },
  setBeforeChangeOptionsCallback: (state, payload) => {
    state.beforeChangeOptionsCallback = payload;
  },
  setAfterChangeOptionsCallback: (state, payload) => {
    state.afterChangeOptionsCallback = payload;
  },
  setAfterChangePageOptionCallback: (state, payload) => {
    state.afterChangePageOptionCallback = payload;
  },
  setInitFinalizeCallback: (state, payload) => {
    state.initFinalizeCallback = payload;
  },
  registerAddToCartCallback: (state, payload) => {
    if (typeof payload === "function")
      state.addToCartCallbacks = [...state.addToCartCallbacks, payload];
  },
  registerOnCartSubmitCallback: (state, payload) => {
    if (typeof payload === "function") state.onCartSubmitCallback = payload;
  },
  setPhotoMappingCallback: (state, payload) => {
    state.photoMappingCallback = payload;
  },
  setIsPageOptionsLoading: (state, payload) => {
    state.isPageOptionsLoading = payload;
  },
  setCallChangeOptions: (state, payload) => {
    state.callChangeOptions = payload;
  },
  setPrevChangeOptionsData: (state, payload) => {
    state.prevChangeOptionsData = payload;
  }
};

const actions = {
  setPageOptionFormat: (
    { commit, getters, rootState, rootGetters, dispatch },
    payload
  ) => {
    commit("setPageOption", {
      getters,
      rootState,
      rootGetters,
      payload,
      dispatch
    });
  },
  setPageOption: (
    { commit, getters, rootState, rootGetters, dispatch },
    payload
  ) => {
    commit("setIsPageOptionsLoading", true);
    commit("setMatrixOneSelection", true);

    if (payload.optionType == "main") {
      if (payload.option == rootGetters.getProductPartsOptionCode) {
        commit("setActiveProductPartName", payload.value);
        commit("setIsPageOptionsLoading", false);
        return;
      } else {
        commit("setPageOption", {
          getters,
          rootState,
          rootGetters,
          payload,
          dispatch
        });
        if (getters.getIsPackingEnabled) {
          dispatch("setPackingOption", payload);
          if (getters.getRefreshGetDataPP.includes(payload.option)) {
            dispatch("packingGetData", { callChangeOptions: false });
          }
        }
      }
    } else {
      // other option
      commit("setOtherOption", {
        getters,
        rootState,
        rootGetters,
        payload,
        dispatch
      });
    }
    if (payload.optionType !== "quantity") {
      payload.pageOptionPayload = {
        getters,
        rootState,
        rootGetters,
        payload,
        dispatch
      };
      dispatch("changeOptions", payload);
    }
    // will be set in changeOptions
    //commit("setIsPageOptionsLoading", false);
  },
  changeOptions: ({ commit, getters, rootState, dispatch }, payload) => {
    if (getters.getIsCimpressProduct && !payload.initialLoading) {
      if (getters.getIsCimpressPreferredSelection) {
        return;
      }
      // validate the token
      if (getters.getCimpressNoQuantity && !payload.keepPricesMatrixSelection) {
        if (!payload.customQuantityChange) {
          dispatch("setCimpresPricesMatrixActiveQty", null);
          dispatch("setCimpresPricesMatrixActiveProdSpeed", null);
        }
      }

      dispatch("validateCimpress", payload);
    } else {
      dispatch("runChangeOptions", payload);
    }
  },
  runChangeOptions: ({ commit, getters, rootState, dispatch }, payload) => {
    if (!getters.getCallChangeOptions || !getters.getCallChangeOptionPerType) {
      if (payload.initialLoading) {
        dispatch("setIsLoading", false);
        dispatch("callInitialLoadingFinalized", {
          type: "changeOptions",
          status: 1
        });
      }
      return;
    }
    if (!payload.changeOptionsLoadingStarted) {
      commit("setIsChangeOptionsLoading", true);
    }

    var changeOptionsPostData = getters.getChangeOptionsPostData(true);
    let resetForceChangeOptions = false;
    if (getters.getActivateResetSelection) {
      changeOptionsPostData = {
        ...changeOptionsPostData,
        ...getters.getResetSelection
      };
      resetForceChangeOptions = true;
      dispatch("setActivateResetSelection", false);
    }
    if (!getters.getIsCimpressProduct && getters.getQuantityCode) {
      if (getters.getIsChangeOptionsEmpty)
        changeOptionsPostData["print_options[quantity][quantity][]"] =
          getters.getQuantityCode;
      else
        changeOptionsPostData["print_options[quantity][quantity]"] = [
          getters.getQuantityCode
        ];
    }

    //cache changeOptions call
    const oldChangeOptionsData = JSON.parse(
      JSON.stringify(getters.getOldChangeOptionsData)
    );
    if (
      !resetForceChangeOptions &&
      hash(changeOptionsPostData) == getters.getPrevChangeOptionsData
    ) {
      // same hash ... no need to call again changeOptions
      commit("setIsChangeOptionsLoading", false);
      commit("setIsPageOptionsLoading", false);
      if (getters.getIsCimpressProduct) {
        commit("moveToNextPageOption", { ...payload.pageOptionPayload });
      }
      return;
    }

    if (
      getters.getCimpressNoQuantity &&
      payload.changeOptionsGetPricesForProduction
    ) {
      dispatch("setCimpressGetPricesChangeOptionsData", {
        changeOptionsPostData
      });
      return;
    }
    commit("setPrevChangeOptionsData", hash(changeOptionsPostData));

    if (getters.getBeforeChangeOptionsCallback) {
      var changeOptionsPostDataResponse = getters.getBeforeChangeOptionsCallback(
        changeOptionsPostData
      );
      if (changeOptionsPostDataResponse) {
        changeOptionsPostData = changeOptionsPostDataResponse;
      }
    }
    axios.instance
      .post(
        getters.getUrl(axios.apiChangeOption),
        qs.stringify(changeOptionsPostData)
      )
      .then(response => {
        if (getters.getAfterChangeOptionsCallback) {
          getters.getAfterChangeOptionsCallback(response.data);
        }

        if (!response.data.success) {
          console.log("Change options error : " + response.data.message);
          throw new Error("Could not get prices for selection");
        }
        if (getters.getIsCimpressProduct) {
          const cimpressState = pathOr(
            null,
            ["data", "cimpress", "state"],
            response.data
          );
          if (
            !getters.getIsChangeOptionsEmpty &&
            constants.CIMPRESS_STATE_UNRESOLVABLE === cimpressState
          ) {
            getters.getSweetAlert({
              text: i18n.t("Invalid selection"),
              icon: "warning"
            });

            commit("setChangeOptionsData", { ...oldChangeOptionsData });
            commit("setIsChangeOptionsLoading", false);
            commit("setIsPageOptionsLoading", false);
            return;
          }
        }
        if (getters.getAfterChangeOptionsCallback) {
          getters.getAfterChangeOptionsCallback(response.data);
        }
        var responseData = response.data;
        if (
          response.data.hasOwnProperty("success") &&
          response.data.hasOwnProperty("data")
        ) {
          responseData = response.data.data;
        }

        if (getters.getIsCimpressPreferredSelection) {
          const preferredData = { ...responseData };
          for (let pp in preferredData.pp_opt) {
            if (pp.startsWith("PP_")) {
              const config_pp = getters.getPOFromProductPartByCode(
                pp.replace("PP_", "")
              );
              for (let po in preferredData.pp_opt[pp]) {
                const configPreferredValue = pathOr(
                  null,
                  [po, "preferred_value"],
                  config_pp
                );
                if (!resetForceChangeOptions && configPreferredValue) {
                  preferredData.pp_opt[pp][po] = [configPreferredValue];
                } else {
                  preferredData.pp_opt[pp][po] = [""];
                }
              }
            }
          }
          commit("setChangeOptionsData", preferredData);
          dispatch("setIsLoading", false);
          commit("setIsChangeOptionsLoading", false);
          commit("setIsPageOptionsLoading", false);
          return;
        }

        commit("setChangeOptionsData", responseData);
        commit(
          "setOldChangeOptionsData",
          JSON.parse(JSON.stringify(responseData))
        );
        if (payload.initialLoading) {
          if (getters.getIsPackingEnabled) {
            dispatch("setPreview3DLoading", true);
            dispatch("loadInitialPackingOptions", payload);
            dispatch("packingGetData", {
              callChangeOptions: true,
              setLoading: true
            });
          } else {
            dispatch("setIsLoading", false);
          }
          dispatch("callInitialLoadingFinalized", {
            type: "changeOptions",
            status: 1
          });
        }
        if (getters.getIsLfp) {
          dispatch("parseChangeOptionResponse", responseData);
        }
        if (responseData.preflight_check_updated) {
          dispatch(
            "setPreflightCheckData",
            responseData.preflight_check_updated
          );
        }

        if (getters.getPhotoMappingCallback && getters.getPhotoMapping) {
          getters.getPhotoMappingCallback(getters.getPhotoMapping);
        }

        if (responseData.template) {
          dispatch("setChangeOptionsTemplate", responseData.template);
        }

        if (
          getters.getIsPackingEnabled &&
          JSON.stringify(getters.getCurrentTdData) !=
            JSON.stringify(getters.getTdTexture)
        ) {
          dispatch("setTdImage");
        }
        if (payload.pageOptionPayload && getters.getIsCimpressProduct) {
          commit("moveToNextPageOption", { ...payload.pageOptionPayload });
        }

        if (payload.initialLoading) {
          if (getters.getCimpressNoQuantity) {
            const cimpressState = pathOr(
              null,
              ["data", "cimpress", "state"],
              response.data
            );
            if (constants.CIMPRESS_STATE_FULLY_RESOLVED === cimpressState) {
              dispatch("runChangeOptions", {
                ...payload,
                changeOptionsLoadingStarted: true,
                changeOptionsGetPricesForProduction: true
              });
              return;
            }
            if (getters.getCimpressNoQuantityAllValuesSelected) {
              dispatch("runChangeOptions", {
                ...payload,
                changeOptionsLoadingStarted: true,
                changeOptionsGetPricesForProduction: true
              });

              return;
            }
          }
        }

        commit("setIsChangeOptionsLoading", false);
        commit("setIsPageOptionsLoading", false);
      })
      .catch(error => {
        console.log(error);
        if (payload.initialLoading) {
          dispatch("setNetworkError", error);
          dispatch("callInitialLoadingFinalized", {
            type: "changeOptions",
            status: 0
          });
          //commit("setIsLoading", false);
        }
        commit("setIsChangeOptionsLoading", false);
        commit("setIsPageOptionsLoading", false);
      });
  },
  setQuantity: ({ commit, getters, dispatch }, payload) => {
    commit("setQuantity", payload);
    dispatch("changeOptions", {});
  },
  setQuantityNoChangeOptions: ({ commit, getters, dispatch }, payload) => {
    commit("setQuantity", payload);
  },
  setQuantityCustom: ({ commit, getters, dispatch }, payload) => {
    commit("setQuantity", payload);
    dispatch("runChangeOptions", { changeOptionsGetPricesForProduction: true });
  },
  setBeforeChangeOptionsCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setBeforeChangeOptionsCallback", payload);
  },
  setAfterChangeOptionsCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setAfterChangeOptionsCallback", payload);
  },
  setAfterChangePageOptionCallback: (
    { commit, getters, dispatch },
    payload
  ) => {
    commit("setAfterChangePageOptionCallback", payload);
  },
  callAfterChangePageOptionCallback: (
    { commit, getters, dispatch },
    payload
  ) => {
    if (payload.type == "main") {
      const allPPOptions = getters.getAllProductPageOptions(true);
      if (allPPOptions[payload.option]) {
        let items;
        if (allPPOptions[payload.option].isRange) {
          items = [payload.value];
        } else {
          items = allPPOptions[payload.option].values.filter(el => {
            return el.value == payload.value;
          });
        }
        if (items.length > 0) {
          getters.getAfterChangePageOptionCallback({
            ...items[0],
            pp: getters.getActiveProductPartCode,
            option: payload.option,
            multiple: allPPOptions[payload.option].type
          });
        } else {
          if (
            payload.option == "format" &&
            payload.value.startsWith("custom_")
          ) {
            const itemsFormat = getters.getCustomFormats.filter(el => {
              return el.value == payload.value;
            });
            if (itemsFormat.length > 0) {
              getters.getAfterChangePageOptionCallback({
                attributes: {
                  width: "" + itemsFormat[0].width,
                  height: "" + itemsFormat[0].height
                },
                label: itemsFormat[0].label,
                value: payload.value,
                pp: getters.getActiveProductPartCode,
                option: payload.option,
                multiple: allPPOptions[payload.option].type
              });
            }
          }
        }
      }
    } else if (payload.type == "other") {
      const options = getters.getWebProductData.options;
      if (options[payload.option]) {
        let items = options[payload.option].values.filter(el => {
          if (options[payload.option].type == "multiple") {
            return payload.value.includes(el.value);
          } else {
            return el.value == payload.value;
          }
        });
        if (options[payload.option].type == "multiple") {
          var newItems = {};
          for (var idx in items) {
            newItems[items[idx].value] = { ...items[idx] };
          }
          items = [{ attributes: newItems }];
        }

        if (items.length > 0) {
          getters.getAfterChangePageOptionCallback({
            ...items[0],
            pp: null,
            option: payload.option,
            value: payload.value,
            multiple: options[payload.option].type
          });
        }
      }
    }
  },
  setInitFinalizeCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setInitFinalizeCallback", payload);
  },
  registerAddToCartCallback: ({ commit, getters, dispatch }, payload) => {
    commit("registerAddToCartCallback", payload);
  },
  registerOnCartSubmitCallback: ({ commit, getters, dispatch }, payload) => {
    commit("registerOnCartSubmitCallback", payload);
  },
  setPhotoMappingCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setPhotoMappingCallback", payload);
  },
  setCallChangeOptions: ({ commit }, payload) => {
    commit("setCallChangeOptions", payload);
  },
  moveToNextPageOption: ({ commit, rootState, getters, dispatch }, payload) => {
    commit("moveToNextPageOption", { rootState, getters, payload, dispatch });
  },
  setIsChangeOptionsLoading: ({ commit }, payload) => {
    commit("setIsChangeOptionsLoading", payload);
  },
  setChangeOptionsData: ({ commit }, payload) => {
    commit("setChangeOptionsData", payload);
  },
  setOldChangeOptionsData: ({ commit }, payload) => {
    commit("setOldChangeOptionsData", payload);
  },
  setCimpressChangeOptionsData: ({ commit }, payload) => {
    commit("setCimpressChangeOptionsData", payload);
  },
  setPageOptionCimpressOneValue: ({ commit, getters }, payload) => {
    commit("setPageOptionCimpressOneValue", { payload, getters });
  },
  setCimpressChangeOptionsDataStatus: ({ commit }, payload) => {
    commit("setCimpressChangeOptionsDataStatus", payload);
  },
  setCimpressGetPricesChangeOptionsData: (
    { commit, getters, dispatch },
    payload
  ) => {
    const changeOptionsPostData = payload.changeOptionsPostData;

    const remainingOptions = getters.getCimpressRemainingOptions({
      pp: getters.getActiveProductPartCode,
      po: "ProductionSpeed"
    });
    changeOptionsPostData["production_speed"] = remainingOptions.values;

    // cache
    if (hash(changeOptionsPostData) == getters.getPrevPricesChangeOptionsData) {
      // same hash ... no need to call again changeOptions
      commit("setIsChangeOptionsLoading", false);
      commit("setIsPageOptionsLoading", false);
      return;
    }
    axios.instance
      .post(
        getters.getUrl(axios.apiChangeOptionGetPrices),
        qs.stringify(changeOptionsPostData)
      )
      .then(response => {
        if (response.data.success) {
          dispatch(
            "setPrevPricesChangeOptionsData",
            hash(changeOptionsPostData)
          );
          dispatch(
            "setCimpressChangeOptionsDataStatus",
            constants.CIMPRESS_STATE_PARTIALLY_RESOLVED
          );
          dispatch("setCimpresPricesMatrixResponse", response.data.data);
        }

        commit("setIsChangeOptionsLoading", false);
        commit("setIsPageOptionsLoading", false);
      })
      .catch(error => {
        console.log(error);
        commit("setIsChangeOptionsLoading", false);
        commit("setIsPageOptionsLoading", false);
      });
  },
  callInitialLoadingFinalized: ({ commit, getters, dispatch }, payload) => {
    if (payload.type == "changeOptions" && payload.status == 1) {
      dispatch("setListenScroll", true);
    }
    if (getters.getInitFinalizeCallback) {
      getters.getInitFinalizeCallback(payload);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
